export default __webpack_public_path__ + "static/media/loga.65a0ce6a.png";